import { css } from "@emotion/react";
export const headerWrapCss = css`
    margin: 0 auto;
    height: 100px;
    width: 100%;
    display: flex;
    flex-direction: row;
    position: relative;
    z-index: 999;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
    border-bottom: 1px solid #BEBEBE;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    z-index: 999;

    @media (min-width: 640px) {
        padding: 24px 40px;
    }

    /* 640px 이하일 때 */
    @media (max-width: 639px) {
        padding: 20px 15px;
        justify-content: space-between;
    }
`;

export const logoBoxCss = css`
    cursor: pointer;

    max-width: 100%;
    align-items: center;
    justify-content: center;
    margin: 0;

    @media (min-width: 640px) {
        position: absolute;
        left: 40px;
        top: 50%;
        transform: translateY(-50%);
    }
`;

export const menuCss = css`
    list-style: none;
    height: 39px;
    display: flex;
    flex-direction: row;
    gap: 40px;
    justify-content: center;
    flex-grow: 1;
    font-family: Pretendard-Bold, serif;
    font-size: 16px;
    color: #161616;
    font-weight: 700;
    padding: 0;

    @media (min-width: 1600px) {
        gap: 70px;
    }

    @media (min-width: 1920px) {
        gap: 110px;
    }

    @media (max-width: 640px) {
        gap: 30px;
    }

    li {
        display: flex;
        flex-direction: column;
        gap: 8px;
        /*margin-right: 50px;*/
        justify-content: center;
        align-items: center;
        cursor: pointer;


        .textActive {
            color: #19cf7a;
            font-family: Pretendard-Bold,serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%;
        }
        .textDeactive {
            color: #161616;
            font-family: Pretendard-Bold,serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 100%;
        }

    }
`;




export const bookPairCss = css`
    list-style: none;
    height: 39px;
    display: flex;
    flex-direction: row;
    gap: 60px;
    justify-content: center;
    flex-grow: 1;
    font-family: Pretendard-Bold, serif;
    font-size: 16px;
    color: #161616;
    font-weight: 700;

    li {
        display: flex;
        flex-direction: column;
        gap: 8px;
        /*margin-right: 50px;*/
        justify-content: center;
        align-items: center;
        cursor: pointer;

      
    }
`;


export const authButtonsCss = css`
    display: flex;
    flex-direction: row;
    max-width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;

    @media (min-width: 640px) {
        position: absolute;
        right: 40px;
        top: 50%;
        transform: translateY(-50%);
    }

    @media (max-width: 640px) {
        display: none;
    }
`;

export const smallIconCss = css`
    display: none;

    @media (max-width: 640px) {
        position: absolute;
        display: block;
        width: 24px;
        height: 24px;
        right: 0;
        margin: 17px 0 30px 0;
    }
`;
